export default __webpack_public_path__ + "static/media/flag-italy.a078bd73.svg";